import React from 'react';

// Material UI
import { Box } from '@material-ui/core';

// Helpers
import className from 'helpers/className';

// Styles
import useStyles from './styles';

export interface BadgeInterface {
  value: number;
  classes?: {
    root?: string;
  };
}

type Props = BadgeInterface;

const Badge: React.FC<Props> = ({ value, classes }) => {
  const { badge } = useStyles();
  return <Box className={className([badge, classes?.root])}>{value}</Box>;
};

export default Badge;
